<app-donut-chart
  [series]="series"
  [loading]="isLoading"
  [options]="options"
  [translateLabels]="true"
></app-donut-chart>
